<style lang="scss">
.distribution-search textarea,
.distribution-search .ivu-select .ivu-select-placeholder {
    font-size: 12px;
}
</style>
<style lang="scss" scoped>
.search-other {
    padding: 9px 10px;
}
.button-container {
    padding-left: 15px;
}
.top-search-item {
    width: 230px;
    margin: 6px;
    margin-right: 20px;
    margin-left: 0;
}
.search-wrap {
    .search-btn {
        margin-bottom: 10px;
    }
    .search-other {
        .more-search-item {
            width: 230px;
            margin-right: 20px;
        }
    }
}
.search-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    &-submit-form {
        margin-top: 6px;
    }
}
</style>

<template>
    <div class="search-wrap searchb2c distribution-search">
        <aside class="search-btn">
            <ButtonGroup>
                <Button
                    v-for="(item, index) in btnsearch"
                    :key="index"
                    :type="
                        changestatus === item.value && changekeys === item.type
                            ? 'primary'
                            : 'default'
                    "
                    @click="handleBtn(item.type, item.value)"
                >
                    {{ item.label }}
                    <span v-if="showTabNum && item.name" class="number">{{
                        tabNumData[item.name]
                    }}</span>
                </Button>
                <compSearchCollect
                    style="display: inline-block"
                    :dataList="collectList"
                    @on-click-item="handleClickCollect"
                    @on-delete-item="handleDeleteCollect"
                ></compSearchCollect>
            </ButtonGroup>
        </aside>
        <article class="search-main">
            <div>
                <Form :label-width="0">
                    <div style="display: flex">
                        <FormItem class="top-search-item">
                            <Input
                                :placeholder="
                                    $t('erp.distribution.deliverorderno', {
                                        defaultValue: '配货单号',
                                    })
                                "
                                clearable
                                v-model.trim="formData.BW_deliverOrderNo"
                            />
                        </FormItem>
                        <FormItem class="top-search-item">
                            <Input
                                :placeholder="
                                    $t('erp.b2c.search_ordernumber', {
                                        defaultValue: '订单号',
                                    })
                                "
                                clearable
                                v-model.trim="sourceNo"
                            />
                        </FormItem>
                        <FormItem class="top-search-item">
                            <DatePicker
                                type="daterange"
                                :options="options"
                                :value="getdate"
                                placement="bottom-end"
                                :placeholder="
                                    $t('global.common.createdtime', {
                                        defaultValue: '创建时间',
                                    })
                                "
                                ref="createdAt"
                                @on-change="handleChange"
                                style="width: 230px"
                            ></DatePicker>
                        </FormItem>
                    </div>
                    <div style="display: flex">
                        <FormItem class="top-search-item">
                            <Select
                                v-model="formData.IN_orgId"
                                filterable
                                clearable
                                multiple
                                style="min-width: 140px"
                                :placeholder="
                                    $t('global.common.organization', {
                                        defaultValue: '组织',
                                    })
                                "
                            >
                                <Option
                                    v-for="item in getOrgList"
                                    :value="item.value"
                                    :key="item.value"
                                    >{{ item.label }}</Option
                                >
                            </Select>
                        </FormItem>
                        <FormItem class="top-search-item">
                            <Select
                                v-model="formData.IN_deliverOrderStatus"
                                filterable
                                clearable
                                multiple
                                :placeholder="
                                    $t('global.common.status', {
                                        defaultValue: '状态',
                                    })
                                "
                            >
                                <Option
                                    v-for="item in deliverOrderStatusList"
                                    :value="item.value"
                                    :key="item.value"
                                    >{{ item.label }}</Option
                                >
                            </Select>
                        </FormItem>
                        <FormItem class="top-search-item">
                            <Select
                                v-model="formData.IN_errorCode"
                                filterable
                                clearable
                                multiple
                                :placeholder="
                                    $t('erp.b2c.search_errorcode', {
                                        defaultValue: '异常类型',
                                    })
                                "
                            >
                                <Option
                                    v-for="item in this.errorcodeList"
                                    :value="item.value"
                                    :key="item.value"
                                    >{{ item.label }}</Option
                                >
                            </Select>
                        </FormItem>
                    </div>
                </Form>
            </div>
            <div>
                <Form class="search-main-submit-form" inline>
                    <Button
                        type="primary"
                        @click="update(true)"
                        icon="ios-search"
                        >{{
                            $t("global.common.btn_search", {
                                defaultValue: "查询",
                            })
                        }}</Button
                    >
                    <Button @click="resetdata" icon="md-refresh">{{
                        $t("global.common.btn_reset", { defaultValue: "重置" })
                    }}</Button>
                    <Button type="dashed" @click="isOpen = !isOpen">
                        {{
                            $t("global.common.btn_more", {
                                defaultValue: "更多查询",
                            })
                        }}
                        <Icon
                            type="ios-arrow-down"
                            class="margin-left-5"
                        ></Icon>
                    </Button>
                    <!-- <span style="float:right;cursor:pointer;margin-top:6px;margin-left:5px;">
                        <Tooltip :content="$t('global.common.helpword',{defaultValue:'帮助文档'})" placement="left">
                            <Icon @click="jumpHelp('http://help.thecopeservices.com/hc/kb/article/1521341/')" class="font-20" type="ios-help-circle-outline" />
                        </Tooltip>
                    </span> -->
                </Form>
            </div>
        </article>
        <transition name="slide-both">
            <div v-show="isOpen">
                <Form class="search-other" :labelWidth="0" inline>
                    <FormItem class="more-search-item">
                        <Select
                            style="min-width: 140px"
                            v-model="formData.IN_channelId"
                            clearable
                            multiple
                            filterable
                            :placeholder="
                                $t('erp.b2c.channel_account', {
                                    defaultValue: '渠道账号',
                                })
                            "
                        >
                            <Option
                                v-for="item in channelAccountList"
                                :key="item.value"
                                :value="item.value"
                                >{{ item.attach.title }}({{
                                    item.attach.flag
                                }})</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Select
                            v-model="formData.IN_lineId"
                            filterable
                            clearable
                            multiple
                            :placeholder="
                                $t('global.common.line', {
                                    defaultValue: '项目',
                                })
                            "
                        >
                            <Option
                                v-for="item in getNewAllProductList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Input
                            v-model="
                                formData['EQ_deliverOrderItemEntityList.erpsku']
                            "
                            clearable
                            placeholder="ERP SKU"
                        ></Input>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Select
                            v-model="formData.IN_orgWarehouseCode"
                            filterable
                            clearable
                            multiple
                            :placeholder="
                                $t('global.common.deliveryWarehouse', {
                                    defaultValue: '发货仓库',
                                })
                            "
                        >
                            <Option
                                v-for="item in warehousesAll"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <!-- <Select
                            v-model="formData.IN_customerCarrierServiceCode"
                            filterable
                            clearable
                            multiple
                            :placeholder="
                                $t('erp.b2c.shipping_method', {
                                    defaultValue: '发货方式',
                                })
                            "
                        >
                            <Option
                                v-for="item in handlesysshippingcode"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select> -->

                        <compMultipleSelect
                            :options="handlesysshippingcode"
                            :modelValue="formData.IN_customerCarrierServiceCode"
                            :placeholder="
                                $t('erp.b2c.shipping_method', {
                                    defaultValue: '发货方式',
                                })
                            "
                            @update:modelValue="changeShip"
                            :vstyle="'max-width:400px'"
                            :isShowCheckAll="false"
                        >
                        </compMultipleSelect>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Select
                            dropStyle="width:auto"
                            v-model="formData['EQ_outboundMode']"
                            clearable
                            :placeholder="
                                $t('erp.b2c.delivery_method', {
                                    defaultValue: '出库方式',
                                })
                            "
                        >
                            <Option
                                v-for="(item, index) in deliveryStatus"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Select
                            dropStyle="width:auto"
                            v-model="formData['EQ_isPallet']"
                            clearable
                            :placeholder="
                                $t('erp.b2c.predeport', {
                                    defaultValue: '预打托',
                                })
                            "
                        >
                            <Option
                                v-for="(item, index) in predeportStatus"
                                :value="item.value"
                                :key="index"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Select
                            v-model="
                                formData[
                                    'IN_saleShipmentPackagesList.logisticStatus'
                                ]
                            "
                            filterable
                            clearable
                            multiple
                            :placeholder="
                                $t('erp.b2c.package_logistics_status', {
                                    defaultValue: '物流状态',
                                })
                            "
                        >
                            <Option
                                v-for="item in this.packStatus"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Input
                            clearable
                            v-model.trim="
                                formData['EQ_saleShipmentPackagesList.trackNo']
                            "
                            placeholder="Tracking"
                        />
                    </FormItem>
                    <FormItem class="more-search-item">
                        <DatePicker
                            type="daterange"
                            :options="options"
                            placement="bottom-end"
                            v-model="getLastestShipDate"
                            :placeholder="
                                $t('erp.b2c.latest_time', {
                                    defaultValue: '最晚发货时间',
                                })
                            "
                            ref="latestShipDate"
                            @on-change="handleChangeLastestShipDate"
                            style="width: 230px"
                        ></DatePicker>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <DatePicker
                            type="daterange"
                            :options="options"
                            placement="bottom-end"
                            v-model="getEstimatedDeliveryDate"
                            :placeholder="
                                $t('erp.distribution.warehouseEstDeliDate', {
                                    defaultValue: '仓库预计发货时间',
                                })
                            "
                            ref="estimatedDeliveryDate"
                            @on-change="handleChangeEstimatedDeliveryDate"
                            style="width: 230px"
                        ></DatePicker>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Select
                            v-model="formData.EQ_isSfp"
                            filterable
                            clearable
                            :placeholder="
                                $t('erp.distribution.issfp', {
                                    defaultValue: '是否sfp',
                                })
                            "
                        >
                            <Option
                                v-for="item in this.isDistributionList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Select
                            v-model="formData.EQ_pickupStatus"
                            clearable
                            style="min-width: 140px"
                            :placeholder="
                                $t('erp.distribution.ispickup', {
                                    defaultValue: '是否可提货',
                                })
                            "
                        >
                            <Option
                                v-for="item in isDistributionList"
                                :value="item.value"
                                :key="item.value"
                                >{{ item.label }}</Option
                            >
                        </Select>
                    </FormItem>
                    <!-- <FormItem class="more-search-item">
                        <Select
                            style="min-width: 140px;"
                            v-model="formData.IN_carrierAccountGroupId"
                            multiple
                            filterable
                            :placeholder="$t('fbb.carrieraccount.carrier_group',{defaultValue:'承运商'})"
                        >
                            <Option
                                v-for="(item,index) in getCarrierCusList"
                                :value="item.value"
                                :key="index"
                            >{{ item.label }}</Option>
                        </Select>
                    </FormItem> -->
                    <FormItem class="more-search-item">
                        <Input
                            v-model="formData['IN_deliverOrderNo']"
                            type="textarea"
                            :placeholder="
                                $t(
                                    'erp.distribution.deliver_order_no_mutiply',
                                    { defaultValue: '配货单号，支持多个' }
                                )
                            "
                        />
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Input
                            v-model="formData['IN_sourceId']"
                            type="textarea"
                            :placeholder="
                                $t('erp.distribution.source_no_mutiply', {
                                    defaultValue: '订单号，支持多个',
                                })
                            "
                        />
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Input
                            v-model="formData['IN_sourceNo']"
                            type="textarea"
                            :placeholder="
                                $t(
                                    'erp.distribution.channel_source_no_mutiply',
                                    { defaultValue: '渠道订单号，支持多个' }
                                )
                            "
                        />
                    </FormItem>
                    <FormItem class="more-search-item">
                        <Button
                            class="pull-right"
                            type="primary"
                            @click="handleShowModal"
                            >{{
                                $t("erp.b2corder.search.save_query", {
                                    defaultValue: "保存当前条件为收藏",
                                })
                            }}</Button
                        >
                    </FormItem>
                </Form>
            </div>
        </transition>
        <transition>
            <Form
                v-if="changekeys == 'EQ_activeStatus'"
                class="search-other button-container"
                inline
            >
                <Button
                    class="margin-right-5"
                    type="info"
                    @click="handleModal('resubmit', true)"
                    >{{
                        $t("global.common.resubmit", {
                            defaultValue: "重新提交",
                        })
                    }}</Button
                >
            </Form>
            <Form inline class="search-other button-container" v-else>
                <Button
                    class="margin-right-5"
                    type="primary"
                    @click="handleModal('resetOrder', true)"
                    >{{
                        $t("erp.disturibution.reset_order", {
                            defaultValue: "重置配货单",
                        })
                    }}</Button
                >
                <Button
                    class="margin-right-5"
                    type="info"
                    @click="handleModal('resubmit', true)"
                    >{{
                        $t("global.common.resubmit", {
                            defaultValue: "重新提交",
                        })
                    }}</Button
                >
                <Button
                    class="margin-right-5"
                    type="warning"
                    @click="handleModal('recovery', true)"
                    >{{
                        $t("erp.b2c.back_normal", { defaultValue: "恢复正常" })
                    }}</Button
                >
                <Button
                    v-if="handleAuth('deliver.order.push')"
                    class="margin-right-5 light-primary"
                    type="success"
                    @click="handleModal('pushWarehouse', true)"
                    >{{
                        $t("erp.b2c.pushyuncang", { defaultValue: "推送仓库" })
                    }}</Button
                >
                <Button
                    v-if="deliverset"
                    class="margin-right-5 dark-primary"
                    @click="handleModal('pushAgain', true)"
                    >{{
                        $t("erp.distribution.pushfile", {
                            defaultValue: "附件推送",
                        })
                    }}</Button
                >
                <Button
                    v-if="contextId != 1000147"
                    class="margin-right-5 light-content"
                    type="success"
                    @click="handleModal('downloadLabel', true)"
                    >{{
                        $t("erp.b2c.download_expressbill", {
                            defaultValue: "下载面单",
                        })
                    }}</Button
                >
                <Button
                    v-if="contextId == 1000147"
                    class="margin-right-5"
                    type="success"
                    @click="handleModal('pickup', true)"
                    >Pickup</Button
                >
                <Dropdown trigger="hover" @on-click="handleBatch">
                    <Button type="error">
                        {{
                            $t("erp.b2c.bulkchanges", {
                                defaultValue: "批量修改",
                            })
                        }}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem
                            v-if="deliverset"
                            name="modifylogistics"
                            >{{
                                $t("erp.b2c.modify_logistics", {
                                    defaultValue: "修改仓库物流",
                                })
                            }}</DropdownItem
                        >
                        <DropdownItem v-if="deliverset" name="addnotes">{{
                            $t("erp.b2c.add_notes", {
                                defaultValue: "添加备注",
                            })
                        }}</DropdownItem>
                        <DropdownItem v-if="delivercancel" name="batchCancel">
                            {{
                                $t("global.common.operation_cancel", {
                                    defaultValue: "取消",
                                })
                            }}
                        </DropdownItem>
                        <DropdownItem
                            v-if="contextId == 1 && deliverset"
                            name="batchChangeLastestTime"
                        >
                            {{
                                $t(
                                    "erp.distribution.batch_change_lastest_deliver_date",
                                    {
                                        defaultValue: "修改最晚发货时间",
                                    }
                                )
                            }}
                        </DropdownItem>
                        <DropdownItem
                            v-if="handleAuth('deliver.order.set')"
                            name="switchissuemethod"
                            >{{
                                $t("erp.b2c.switch_issue_method", {
                                    defaultValue: "切换出库方式",
                                })
                            }}</DropdownItem
                        >
                        <!-- <DropdownItem
                            name="removeexcept"
                        >{{$t('erp.b2c.back_normal_onlyremove',{defaultValue:'恢复正常(仅去除异常)'})}}</DropdownItem> -->
                    </DropdownMenu>
                </Dropdown>
                <!-- <compLabelSelect class="margin-left-5" type="primary" :dataList="$parent.labelList" @on-add="handleLabel" @on-remove="handleLabel" @on-change="handleLabel">
                    标签
                    <Icon type="md-arrow-dropdown" />
                </compLabelSelect> -->
                <Dropdown
                    class="pull-right"
                    trigger="hover"
                    @on-click="handleModal"
                >
                    <Button type="info">
                        {{
                            $t("global.common.import_export", {
                                defaultValue: "导入/出",
                            })
                        }}
                        <Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem v-if="deliverexport">
                            <div @click="this.exportXlsx">
                                {{
                                    $t("global.common.condition_export", {
                                        defaultValue: "查询条件导出",
                                    })
                                }}
                            </div>
                        </DropdownItem>
                        <DropdownItem v-if="deliverset" name="wordImport">{{
                            $t("erp.b2c.arrachement_upload", {
                                defaultValue: "附件上传",
                            })
                        }}</DropdownItem>
                        <!-- 只有bizark组织展示upc导入 -->
                        <DropdownItem
                            v-if="contextId == 1 && deliverset"
                            name="upcImport"
                            >{{
                                $t("erp.distribution.import_upc", {
                                    defaultValue: "UPC导入",
                                })
                            }}</DropdownItem
                        >
                        <DropdownItem
                            v-if="deliverset && contextId !== 1000147"
                            name="arnImport"
                            >{{
                                $t("erp.distribution.import_arn", {
                                    defaultValue: "ARN导入",
                                })
                            }}</DropdownItem
                        >
                        <DropdownItem
                            v-if="b2cOrdertracking"
                            name="trackingImport"
                            >{{
                                $t("erp.b2c.tracking_import_button", {
                                    defaultValue: "Tracking导入",
                                })
                            }}</DropdownItem
                        >
                    </DropdownMenu>
                </Dropdown>
            </Form>
        </transition>
        <Modal
            v-model="modalProps.show"
            :mask-closable="false"
            :footer-hide="true"
            :title="modalProps.title"
            v-bind="modalProps"
        >
            <Spin v-if="modalProps.modalLoading" fix></Spin>
            <Form :model="modalData" :labelWidth="80">
                <FormItem
                    :label="
                        $t('erp.b2corder.serach_query_name', {
                            defaultValue: '查询名称',
                        })
                    "
                    prop="searchName"
                >
                    <Input
                        :placeholder="
                            $t('erp.b2corder.search_please_enter_name', {
                                defaultValue: '请输入名称',
                            })
                        "
                        v-model="modalData.searchName"
                    />
                </FormItem>
            </Form>
            <div>
                <Button
                    class="margin-right-15"
                    type="primary"
                    @click="saveSearch"
                    >{{
                        $t("global.modal.confirm", { defaultValue: "确定" })
                    }}</Button
                >
                <Button type="default" @click="cancelModal">{{
                    $t("global.common.operation_cancel", {
                        defaultValue: "取消",
                    })
                }}</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
// 多语言 this.$i18n.t('product.list.all')
import {
    HttpGetIconList,
    HttpAddIcons,
    HttpGetCategories,
} from "@/service/products/allproducts";
import {
    HttpGetSearchCollect,
    HttpAddSearchCollect,
    HttpDeleteSearchCollect,
    HttpGetSearchCollectById,
    HttpGetAllCustomerIdCode,
} from "@/service/boss/b2corder";
import { HttpWarehouseAllList } from "@mods/service/dictionary";
import { HttpAccountAllList } from "@/service/boss/dictionary";
import compSearchCollect from "@/views/components/searchcollect.vue";
import { mapState, mapGetters } from "vuex";

export default {
    components: {
        compSearchCollect,
    },
    watch: {
        formData: {
            deep: true,
            handler(newData, oldData) {
                if (newData.GE_createdAt) {
                    this.getdate = [newData.GE_createdAt, newData.LE_createdAt];
                } else {
                    this.getdate = [];
                }
            },
        },
    },
    data() {
        return {
            contextId: global.SYSID,
            changestatus: "",
            changekeys: "EQ_enable",
            isOpen: false,
            getdate: [],
            getLastestShipDate: [],
            getEstimatedDeliveryDate: [],
            formData: {
                IN_orgId: "",
                BW_deliverOrderNo: "",
                IN_lineId: "",
                IN_orgWarehouseId: "",
                IN_orgWarehouseCode: "",
                IN_deliverOrderStatus: "",
                IN_customerCarrierServiceCode: "",
                IN_errorCode: "",
                EQ_outboundMode: "",
                EQ_isPallet: "",
                "IN_saleShipmentPackagesList.logisticStatus": "",
                "EQ_saleShipmentPackagesList.trackNo": "",
                EQ_isSfp: "",
                GE_createdAt: "",
                LE_createdAt: "",
                GE_latestShipDate: "",
                LE_latestShipDate: "",
                GE_warehouseLastOutboundDate: "",
                LE_warehouseLastOutboundDate: "",
            },
            sourceNo: this.$route.query.sourceNo
                ? this.$route.query.sourceNo
                : "",
            showTabNum: "",
            modalProps: {
                show: false,
                modalLoading: false,
            },
            modalData: {
                searchName: "",
            },
            collectList: [],
            handlesysshippingcode: [],
            warehouseList: [],
            channelAccountList: [],
        };
    },
    created() {
        this.deliverexport = this.handleAuth("deliver.order.export");
        this.deliverset = this.handleAuth("deliver.order.set");
        this.delivercancel = this.handleAuth("deliver.order.cancel");
        this.b2cOrdertracking = this.handleAuth("deliver.order.trackingImport");
        // console.log(this.deliverset)
        this.getWarehouseList();
        this.getChannelAccountList();

        if (!this.$route.query.sourceNo) {
            this.timehandle();
        }
        HttpGetAllCustomerIdCode().then(
            (res) => {
                let serviceCodeList = res.data.map((item) => {
                    return {
                        label: `${item.code}(${item.carrierServiceName})`,
                        value: item.code,
                        attach: {
                            ...item,
                        },
                    };
                });
                this.handlesysshippingcode = serviceCodeList;
            },
            (err) => {
                console.log(err);
            }
        );
    },
    mounted() {
        this.getSearchCollect();
        this.update();
        this.bus.$on("changelang", (val) => {
            setTimeout(() => {
                this.update(true);
            }, 600);
        });
    },
    computed: {
        ...mapGetters("diction", [
            "getNewAllProductList",
            "getNewAllAccountIdList",
        ]),
        //...mapGetters('diction', ['getNewProductList', 'getNewWarehouseIdList']),
        ...mapGetters("dictionary", [
            "getOrgList",
            "getNewAllWarehouseIdList",
            "getCarrierCusList",
        ]),
        ...mapState("boss", ["sysshippingcode"]),
        isDistributionList() {
            return [
                {
                    value: 1,
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                },
                {
                    value: 0,
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                },
            ];
        },
        deliverOrderStatusList() {
            return [
                {
                    value: "5",
                    label: "Draft" + "(草稿)",
                },
                {
                    value: "0",
                    label: "Created" + "(已创建)",
                },
                {
                    value: "1",
                    label: "Pushed" + "(已推送)",
                },
                {
                    value: "2",
                    label: "Shipped" + "(已发货)",
                },
                {
                    value: "3",
                    label: "Canceled" + "(已取消)",
                },
            ];
        },
        errorcodeList() {
            return [
                {
                    value: "00000",
                    label: "Unexception" + "(无异常)",
                },
                {
                    value: "8888",
                    label:
                        "Shipping Label Generating - System Exception" +
                        "(购买面单-系统异常)",
                },
                {
                    value: "800",
                    label: "Distribution Exception" + "(配货异常)",
                },
                {
                    value: "500",
                    label: "System Exception" + "(系统异常)",
                },
                {
                    value: "7777",
                    label: "Carrier Exception" + "(发运方式异常)",
                },
                {
                    value: "4444",
                    label: "Shipping label generating error" + "(购买面单异常)",
                },
                {
                    value: "6666",
                    label: "Attachment Upload Exception" + "(附件上传异常)",
                },
                {
                    value: "5555",
                    label: "Receive Exception" + "(回传异常)",
                },
                {
                    value: "1111",
                    label: "Transfer Error" + "(推送异常)",
                },
                {
                    value: "2222",
                    label: "File Error" + "(附件推送异常)",
                },
                {
                    value: "3333",
                    label: "Label Error" + "(推送label系统异常)",
                },
            ];
        },
        warehousesAll() {
            let existCode = [];
            let arr = [];
            this.warehouseList.map((item) => {
                if (existCode.indexOf(item.attach.code) < 0) {
                    existCode.push(item.attach.code);
                    // console.log(existCode)
                    let data = {
                        value: item.attach.code,
                        label: item.label,
                    };
                    arr.push(data);
                }
            });
            return arr;
        },
        btnsearch() {
            return [
                {
                    value: "",
                    type: "EQ_enable",
                    label: this.$t("global.common.all", {
                        defaultValue: "全部",
                    }),
                },
                {
                    value: "0",
                    type: "NE_errorCode",
                    label: this.$t("global.common.errorCode", {
                        defaultValue: "异常",
                    }),
                },
                {
                    value: "0",
                    type: "EQ_activeStatus",
                    label: this.$t("erp.distribution.wait_to_active", {
                        defaultValue: "待激活",
                    }),
                },
            ];
        },
        options() {
            return {
                shortcuts: [
                    {
                        text: this.$t("global.common.latest_week", {
                            defaultValue: "最近一周",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 7
                            );
                            return [start, end];
                        },
                    },
                    {
                        text: this.$t("global.common.recent_month", {
                            defaultValue: "最近一月",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 30
                            );
                            return [start, end];
                        },
                    },
                    {
                        text: this.$t("global.common.latest_quarter", {
                            defaultValue: "最近一季度",
                        }),
                        value() {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(
                                start.getTime() - 3600 * 1000 * 24 * 90
                            );
                            return [start, end];
                        },
                    },
                ],
            };
        },
        deliveryStatus() {
            return [
                {
                    value: 0,
                    label: this.$t("erp.b2c.direct_issue", {
                        defaultValue: "直接出库",
                    }),
                },
                {
                    value: 1,
                    label: this.$t("erp.b2c.goods_collection", {
                        defaultValue: "集货出库-不上报打托信息",
                    }),
                },
                {
                    value: 2,
                    label: this.$t("erp.b2c.goods_collection_underpinning", {
                        defaultValue: "集货出库-上报打托信息",
                    }),
                },
            ];
        },
        predeportStatus() {
            return [
                {
                    value: 1,
                    label: this.$t("erp.global.yes", { defaultValue: "是" }),
                },
                {
                    value: 0,
                    label: this.$t("erp.global.no", { defaultValue: "否" }),
                },
            ];
        },
        packStatus() {
            return [
                {
                    value: 0,
                    label: "UNKNOWN",
                    color: "color-warning",
                },
                {
                    value: 1,
                    label: "PRE_TRANSIT",
                    color: "color-primary",
                },
                {
                    value: 2,
                    label: "IN_TRANSIT",
                    color: "color-success",
                },
                {
                    value: 3,
                    label: "OUT_FOR_DELIVERY",
                    color: "color-warning",
                },
                {
                    value: 4,
                    label: "DELIVERED",
                    color: "color-error",
                },
                {
                    value: 5,
                    label: "AVAILABLE_FOR_PICKUP",
                    color: "color-error",
                },
                {
                    value: 6,
                    label: "RETURN_TO_SENDER",
                    color: "",
                },
                {
                    value: 7,
                    label: "FAILURE",
                    color: "",
                },
                {
                    value: 8,
                    label: "CANCELLED",
                    color: "",
                },
                {
                    value: 9,
                    label: "ERROR",
                    color: "",
                },
                {
                    value: 11,
                    label: "Label Created",
                    color: "",
                },
            ];
        },
        propsData() {
            return [
                {
                    label: this.$t("erp.distribution.deliverorderno", {
                        defaultValue: "配货单号",
                    }),
                    key: "BW_deliverOrderNo",
                },
                // {label:this.$t('erp.b2c.search_ordernumber', {defaultValue: '订单号'}),key:'sourceNo',deletetag:'deletetag'},
                {
                    label: this.$t("global.common.createdtime", {
                        defaultValue: "创建时间",
                    }),
                    key: ["GE_createdAt", "LE_createdAt"],
                    tag: "timearray",
                },
                {
                    label: this.$t("global.common.line", {
                        defaultValue: "项目",
                    }),
                    key: "IN_lineId",
                    tag: "Select",
                    value: this.getNewAllProductList,
                    props: "multiple",
                },
                {
                    label: this.$t("global.common.status", {
                        defaultValue: "状态",
                    }),
                    key: "IN_deliverOrderStatus",
                    tag: "Select",
                    value: this.deliverOrderStatusList,
                    props: "multiple",
                },
                {
                    label: this.$t("erp.b2c.search_outwarehouse", {
                        defaultValue: "发货仓库",
                    }),
                    key: "IN_orgWarehouseCode",
                    tag: "Select",
                    value: this.warehousesAll,
                    props: "multiple",
                },
                {
                    label: this.$t("erp.b2c.shipping_method", {
                        defaultValue: "发货方式",
                    }),
                    key: "IN_customerCarrierServiceCode",
                    tag: "Select",
                    value: this.handlesysshippingcode,
                    props: "multiple",
                },
                {
                    label: this.$t("erp.b2c.delivery_method", {
                        defaultValue: "出库方式",
                    }),
                    key: "EQ_outboundMode",
                    tag: "Select",
                    value: this.deliveryStatus,
                },
                {
                    label: this.$t("erp.b2c.predeport", {
                        defaultValue: "预打托",
                    }),
                    key: "EQ_isPallet",
                    tag: "Select",
                    value: this.predeportStatus,
                },
                {
                    label: this.$t("erp.b2c.package_logistics_status", {
                        defaultValue: "物流状态",
                    }),
                    key: "IN_saleShipmentPackagesList.logisticStatus",
                    tag: "Select",
                    value: this.packStatus,
                    props: "multiple",
                },
                {
                    label: "Tracking",
                    key: "EQ_saleShipmentPackagesList.trackNo",
                },
                {
                    label: this.$t("erp.b2c.search_isSFPorder", {
                        defaultValue: "是否SFP订单",
                    }),
                    key: "EQ_isSfp",
                    tag: "Select",
                    value: this.isDistributionList,
                },
                {
                    label: this.$t("erp.b2c.search_errorcode", {
                        defaultValue: "异常类型",
                    }),
                    key: "IN_errorCode",
                    tag: "Select",
                    value: this.errorcodeList,
                    props: "multiple",
                },
                {
                    label: this.$t("global.common.organization", {
                        defaultValue: "组织",
                    }),
                    key: "IN_orgId",
                    tag: "Select",
                    value: this.getOrgList,
                    props: "multiple",
                },
                {
                    label: this.$t("erp.distribution.ispickup", {
                        defaultValue: "是否可提货",
                    }),
                    key: "EQ_pickupStatus",
                    tag: "Select",
                    value: this.isDistributionList,
                },
                // {label:this.$t('fbb.carrieraccount.carrier_group',{defaultValue:'承运商'}),key:'EQ_carrierAccountGroupId',tag:'Select',value:this.getCarrierCusList},
                {
                    label: "ERPSKU",
                    key: "EQ_deliverOrderItemEntityList.erpsku",
                },
                {
                    label: this.$t("erp.b2c.channel_account", {
                        defaultValue: "渠道账号",
                    }),
                    key: "IN_channelId",
                    tag: "Select",
                    value: this.channelAccountList,
                    props: "multiple",
                },
                {
                    label: this.$t(
                        "erp.distribution.deliver_order_no_mutiply",
                        { defaultValue: "配货单号，支持多个" }
                    ),
                    key: "IN_deliverOrderNo",
                    text: "text",
                },
                {
                    label: this.$t("erp.distribution.source_no_mutiply", {
                        defaultValue: "订单号，支持多个",
                    }),
                    key: "IN_sourceId",
                    text: "text",
                },
                {
                    label: this.$t(
                        "erp.distribution.channel_source_no_mutiply",
                        { defaultValue: "渠道订单号，支持多个" }
                    ),
                    key: "IN_sourceNo",
                    text: "text",
                },
            ];
        },
    },
    methods: {
        // 切换发货方式
        changeShip(val) {
            this.formData.IN_customerCarrierServiceCode = val;
        },
        getWarehouseList() {
            HttpWarehouseAllList().then(
                (res) => {
                    this.warehouseList = res.data.map((item) => ({
                        value: item.id,
                        label: `${item.code}(${item.title})`,
                        attach: {
                            code: item.code,
                            warehouseType: item.warehouseType,
                            orgId: item.organizationId,
                            apiType: item.apiType,
                        },
                    }));
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        getChannelAccountList() {
            HttpAccountAllList().then(
                (res) => {
                    this.channelAccountList = res.data.map((item) => ({
                        value: item.id,
                        label: `${item.title}(${item.flag})`,
                        attach: {
                            ...item,
                        },
                    }));
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleShowModal() {
            this.modalProps.show = true;
            this.modalProps.title = this.$t(
                "erp.b2corder.search_create_fast_query_name",
                { defaultValue: "创建快捷查询名称" }
            );
        },
        handleDeleteCollect(item) {
            this.$parent.handleDeleteCollect((callback) => {
                HttpDeleteSearchCollect({
                    ids: item.id,
                })
                    .then(
                        (res) => {
                            this.$VMessage.success(res.message);
                            this.getSearchCollect();
                        },
                        (err) => {
                            this.$VMessage.error(err.message);
                        }
                    )
                    .finally(() => {
                        callback();
                    });
            });
        },
        cancelModal() {
            this.modalProps.show = false;
            this.modalData = {};
        },
        handleClickCollect(item) {
            // let formData = {};
            this.resetdata();
            this.formData["GE_createdAt"] = "";
            this.formData["LE_createdAt"] = "";
            this.getdate = [];
            item.items.map((searchItem) => {
                let searchData = searchItem.searchData;
                // string
                if (searchItem.searchData.indexOf("$") !== -1) {
                    if (searchItem.searchData.indexOf("$") === 0) {
                        searchData = searchItem.searchData.replace("$", "");
                    } else {
                        searchData = searchItem.searchData.split("$");
                    }
                }
                // number
                else if (searchItem.searchData.indexOf("#") !== -1) {
                    if (searchItem.searchData.indexOf("#") === 0) {
                        searchData = searchItem.searchData.replace("#", "");
                        console.log(searchData);
                        searchData = parseInt(searchData);
                    } else {
                        searchData = searchItem.searchData.split("#");
                        searchData = searchData.map((id) => {
                            return parseInt(id);
                        });
                    }
                }
                this.$set(this.formData, searchItem.searchOpField, searchData);
                // formData[searchItem.searchOpField] = searchData;
            });
            // console.log(formData)
            // formData = {
            //     ...this.formData,
            //     ...formData
            // }

            // this.$set(this, 'formData', formData);
            // console.log(this.formData);
            this.update(true);
        },
        saveSearch() {
            // console.log(this.formData);
            let formDataArray = [];
            Object.keys(this.formData).map((key) => {
                if (this.formData[key]) {
                    if (key == "NE_errorCode" || key == "EQ_activeStatus")
                        return;
                    // console.log('key', key, 'value', this.formData[key]);
                    if (Array.isArray(this.formData[key])) {
                        if (this.formData[key].length) {
                            let flag = "$";
                            if (typeof this.formData[key][0] === "string") {
                                flag = "$";
                            } else if (
                                typeof this.formData[key][0] === "number"
                            ) {
                                flag = "#";
                            }
                            let data = {};
                            if (this.formData[key].length < 2) {
                                data = {
                                    searchOpField: key,
                                    searchData: flag + this.formData[key][0],
                                };
                            } else {
                                data = {
                                    searchOpField: key,
                                    searchData: this.formData[key].join(flag),
                                };
                            }
                            formDataArray.push(data);
                        }
                    } else {
                        let value = this.formData[key];
                        if (typeof value === "number") {
                            value = "#" + value;
                        }
                        let data = {
                            searchOpField: key,
                            searchData: value,
                        };
                        formDataArray.push(data);
                    }
                }
            });
            if (!formDataArray.length)
                return this.$VMessage.error(
                    this.$t("erp.b2corder.search_warning_query_one", {
                        defaultValue: "至少填写一组查询条件",
                    })
                );
            if (!this.modalData.searchName)
                return this.$VMessage.error(
                    this.$t("erp.b2corder.search_warning.query_name_not_null", {
                        defaultValue: "查询名称不能为空",
                    })
                );
            this.modalProps.modalLoading = true;
            HttpAddSearchCollect({
                orgId: global.SYSID,
                module: "deliverOrder",
                searchName: this.modalData.searchName,
                items: formDataArray,
            })
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.getSearchCollect();
                        this.cancelModal();
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                )
                .finally(() => {
                    this.modalProps.modalLoading = false;
                });
        },
        getSearchCollect() {
            // stage环境暂时隐藏查询收藏
            let isStage = location.host.indexOf("stage") >= 0 ? true : false;
            if (isStage) return (this.collectList = []);
            HttpGetSearchCollect({
                module: "deliverOrder",
            }).then(
                (res) => {
                    // console.log(res);
                    this.collectList = res.data;
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleLabel(type, labelIds) {
            // console.log(type, labelIds);
            if (type === "change") {
                this.$parent.handleLabelChange(labelIds);
            } else {
                this.$parent.handleLabel(type, labelIds);
            }
        },
        handleChangeLastestShipDate(date) {
            this.formData.GE_latestShipDate = date[0];
            this.formData.LE_latestShipDate = date[1];
        },
        handleChangeEstimatedDeliveryDate(date) {
            this.formData.GE_warehouseLastOutboundDate = date[0];
            this.formData.LE_warehouseLastOutboundDate = date[1];
        },
        handleBatch(name) {
            this.handleModal(name, true);
        },
        timehandle() {
            // if()
            this.formData.GE_createdAt = this.getDay(-7);
            this.formData.LE_createdAt = this.getDay(0);
            this.getdate = [
                this.formData.GE_createdAt,
                this.formData.LE_createdAt,
            ];
        },
        // 封装时间函数
        getDay(day) {
            var today = new Date();
            var targetday_milliseconds =
                today.getTime() + 1000 * 60 * 60 * 24 * day;
            today.setTime(targetday_milliseconds); //注意，这行是关键代码
            var tYear = today.getFullYear();
            var tMonth = today.getMonth();
            var tDate = today.getDate();
            tMonth = this.doHandleMonth(tMonth + 1);
            tDate = this.doHandleMonth(tDate);
            return tYear + "-" + tMonth + "-" + tDate;
        },
        doHandleMonth(month) {
            var m = month;
            if (month.toString().length == 1) {
                m = "0" + month;
            }
            return m;
        },

        getcategory() {
            HttpGetCategories().then(
                (res) => {
                    this.categoryList = res.data.filter((item) => {
                        return item.level == 3;
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
        },
        handleBtn(key, val, index) {
            // console.log(key,val)
            this.changestatus = val;
            this.changekeys = key;
            this.$set(this.formData, key, val);
            // 选中全部
            if (key === "EQ_enable" && val === "") {
                this.$set(this.formData, "NE_errorCode", "");
            }
            if (key !== "EQ_activeStatus") {
                this.$set(this.formData, "EQ_activeStatus", "");
            }
            if (key !== "NE_errorCode") {
                this.$set(this.formData, "NE_errorCode", "");
            }
            this.update();
            // this.formData
        },
        handleModal(type, id) {
            // console.log(type,id)
            this.$parent.handleOperates("", type, id);
        },

        handleChange(date) {
            this.formData.GE_createdAt = date[0];
            this.formData.LE_createdAt = date[1];
        },
        update(type, parms) {
            // console.log(1111)
            var filters = "";
            if (this.sourceNo) {
                filters = `{"groupOp": "OR", "rules": [{ "field": "sourceNo", "op": "eq", "data": "${this.sourceNo}" },{ "field": "sourceId", "op": "eq", "data": "${this.sourceNo}" }]}`;
            }
            // 配货单号和订单号查询时自动清除创建时间
            if (this.formData["BW_deliverOrderNo"] || this.sourceNo) {
                // console.log(this.formData, filters);
                this.getdate = [];
                this.formData["GE_createdAt"] = "";
                this.formData["LE_createdAt"] = "";
            }
            let search = {
                IN_deliverOrderNo: "",
                IN_sourceId: "",
                IN_sourceNo: "",
            };
            if (
                this.formData.IN_deliverOrderNo &&
                this.formData.IN_deliverOrderNo != ""
            ) {
                let INid = this.formData.IN_deliverOrderNo.replace(/\n/g, ",");
                search.IN_deliverOrderNo = INid.split(",");
            }
            if (this.formData.IN_sourceId && this.formData.IN_sourceId != "") {
                let INid = this.formData.IN_sourceId.replace(/\n/g, ",");
                search.IN_sourceId = INid.split(",");
            }
            if (this.formData.IN_sourceNo && this.formData.IN_sourceNo != "") {
                let INid = this.formData.IN_sourceNo.replace(/\n/g, ",");
                search.IN_sourceNo = INid.split(",");
            }
            const formdata = {
                ...this.formData,
                ...search,
            };
            this.$emit("on-update", {
                search: formdata,
                page: 1,
                sidx: "warehouseLastOutboundDate,id",
                filters: filters,
            });
        },
        resetdata() {
            this.formData = {
                IN_orgId: "",
                BW_deliverOrderNo: "",
                IN_lineId: "",
                IN_orgWarehouseId: "",
                IN_orgWarehouseCode: "",
                IN_deliverOrderStatus: "",
                IN_customerCarrierServiceCode: "",
                EQ_outboundMode: "",
                EQ_isPallet: "",
                "IN_saleShipmentPackagesList.logisticStatus": "",
                "EQ_saleShipmentPackagesList.trackNo": "",
                IN_errorCode: "",
                GE_createdAt: "",
                LE_createdAt: "",
                GE_latestShipDate: "",
                LE_latestShipDate: "",
                GE_warehouseLastOutboundDate: "",
                LE_warehouseLastOutboundDate: "",
            };
            this.sourceNo = "";
            this.timehandle();
            this.getLastestShipDate = [];
            this.getEstimatedDeliveryDate = [];
            this.$emit("on-update", {
                search: {
                    ...this.formData,
                },
                page: 1,
                sidx: "warehouseLastOutboundDate,id",
                filters: "",
            });
        },
        handleArray(str) {
            if (!str) return;
            if (Array.isArray(str)) return;
            return str.replace(/\n/g, ",").split(",");
        },
        exportXlsx() {
            if (sessionStorage.get("downloadTotal") > 5000) {
                this.$Message.error(
                    this.$t("erp.b2c.export_data_5000", {
                        defaultValue: "请导出5000条以内的数据",
                    })
                );
            } else {
                var filters = "";
                if (this.sourceNo) {
                    filters = `{"groupOp": "OR", "rules": [{ "field": "sourceNo", "op": "eq", "data": "${this.sourceNo}" },{ "field": "sourceId", "op": "eq", "data": "${this.sourceNo}" }]}`;
                }
                this.handleWebfs(
                    process.env.VUE_APP_APIURL_BOSS +
                        "/api/v2/DeliverOrder/exportXlsx",
                    {
                        "search[IN_orgId]": this.formData.IN_orgId
                            ? this.formData.IN_orgId
                            : "",
                        "search[BW_deliverOrderNo]": this.formData
                            .BW_deliverOrderNo
                            ? this.formData.BW_deliverOrderNo
                            : "",
                        "search[IN_lineId]": this.formData.IN_lineId
                            ? this.formData.IN_lineId
                            : "",
                        "search[EQ_isPallet]": this.formData.EQ_isPallet
                            ? this.formData.EQ_isPallet
                            : "",
                        "search[EQ_outboundMode]":
                            this.formData.EQ_outboundMode == ""
                                ? this.formData.EQ_outboundMode
                                : "",
                        "search[IN_saleShipmentPackagesList.logisticStatus]":
                            this.formData[
                                "IN_saleShipmentPackagesList.logisticStatus"
                            ]
                                ? this.formData[
                                      "IN_saleShipmentPackagesList.logisticStatus"
                                  ]
                                : "",
                        "search[EQ_saleShipmentPackagesList.trackNo]": this
                            .formData["EQ_saleShipmentPackagesList.trackNo"]
                            ? this.formData[
                                  "EQ_saleShipmentPackagesList.trackNo"
                              ]
                            : "",
                        "search[IN_orgWarehouseId]": this.formData
                            .IN_orgWarehouseId
                            ? this.formData.IN_orgWarehouseId
                            : "",
                        "search[IN_orgWarehouseCode]": this.formData
                            .IN_orgWarehouseCode
                            ? this.formData.IN_orgWarehouseCode
                            : "",
                        "search[IN_customerCarrierServiceCode]": this.formData
                            .IN_customerCarrierServiceCode
                            ? this.formData.IN_customerCarrierServiceCode
                            : "",
                        "search[IN_deliverOrderStatus]": this.formData
                            .IN_deliverOrderStatus
                            ? this.formData.IN_deliverOrderStatus
                            : "",
                        // "search[EQ_customerCarrierServiceCode]": this.formData
                        //     .EQ_customerCarrierServiceCode
                        //     ? this.formData.EQ_customerCarrierServiceCode
                        //     : "",
                        "search[IN_errorCode]": this.formData.IN_errorCode
                            ? this.formData.IN_errorCode
                            : "",
                        "search[GE_createdAt]": this.formData.GE_createdAt
                            ? this.formData.GE_createdAt
                            : "",
                        "search[LE_createdAt]": this.formData.LE_createdAt
                            ? this.formData.LE_createdAt
                            : "",
                        "search[GE_latestShipDate]": this.formData
                            .GE_latestShipDate
                            ? this.formData.GE_latestShipDate
                            : "",
                        "search[LE_latestShipDate]": this.formData
                            .LE_latestShipDate
                            ? this.formData.LE_latestShipDate
                            : "",
                        "search[GE_warehouseLastOutboundDate ]": this.formData
                            .GE_warehouseLastOutboundDate
                            ? this.formData.GE_warehouseLastOutboundDate
                            : "",
                        "search[LE_warehouseLastOutboundDate ]": this.formData
                            .LE_warehouseLastOutboundDate
                            ? this.formData.LE_warehouseLastOutboundDate
                            : "",
                        "search[IN_channelId]": this.formData.IN_channelId
                            ? this.formData.IN_channelId
                            : "",
                        "search[IN_sourceNo]": this.handleArray(
                            this.formData.IN_sourceNo
                        )
                            ? this.handleArray(this.formData.IN_sourceNo)
                            : "",
                        "search[IN_sourceId]": this.handleArray(
                            this.formData.IN_sourceId
                        )
                            ? this.handleArray(this.formData.IN_sourceId)
                            : "",
                        "search[IN_deliverOrderNo]": this.handleArray(
                            this.formData.IN_deliverOrderNo
                        )
                            ? this.handleArray(this.formData.IN_deliverOrderNo)
                            : "",
                        "search[NE_errorCode]": this.formData.NE_errorCode
                            ? this.formData.NE_errorCode
                            : "",
                        filters: filters,
                    },
                    {
                        executor: "request",
                        download: true,
                    }
                ).catch((err) => {
                    // this.$VMessage.error(err.message);
                });
            }
        },
    },
};
</script>
